import React from 'react';
import Icon from '../../components/AppIcon';
import { Link } from 'react-router-dom';
import TopNavigation from '../../components/TopNavigation';
import Footer from '../../components/Footer';
import PartnersSection from '../about/components/PartnersSection';

const TrainingPlatformUseCaseDetail = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <TopNavigation />
      
      {/* Hero Section */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Two Column Layout */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      
      {/* Left Column - Text Content */}
      <div>
        {/* Badge */}
        <div 
          className="inline-flex items-center px-4 py-2 rounded-md text-xs font-bold tracking-wider mb-8"
          style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38', color: '#E8EDDF' }}
        >
          SLEEVE TRAINING PLATFORM
        </div>
        
        {/* Title */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold  leading-tight mb-6" style={{ color: '#E8EDDF' }}>
          Eliminate Your Hardware Bottleneck. Instantly.
        </h1>
        
        {/* Description */}
        <p className="text-lg md:text-xl leading-relaxed mb-10" style={{ color: '#9CA3AF' }}>
          On-demand, in-browser access to a $50K+ embedded lab stack — real hardware, real tools, zero setup.
        </p>
        
        {/* Buttons */}
        <div className="flex flex-wrap gap-4">
          <a 
            href="/start"
            className="inline-flex items-center justify-center px-6 py-4 rounded-lg font-semibold text-base transition-colors"
            style={{ backgroundColor: '#4FB3B8', color: '#242423' }}
          >
            Start Your Free 30-Minute Lab
          </a>
          <a 
            href="/contact"
            className="inline-flex items-center justify-center gap-2 px-6 py-4 rounded-lg font-semibold text-base transition-colors"
            style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38', color: '#F5CB5C' }}
          >
            Request Team Training Quote
          </a>
        </div>
      </div>
      
      {/* Right Column - Browser Mockup */}
      <div 
        className="rounded-xl overflow-hidden"
        style={{ backgroundColor: '#242423', border: '2px solid #4FB3B8' }}
      >
        {/* Browser Chrome */}
        <div className="flex items-center gap-3 px-4 py-3" style={{ backgroundColor: '#1a1a19' }}>
          {/* Traffic Lights */}
          <div className="flex gap-2">
            <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#FF5F56' }}></div>
            <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#FFBD2E' }}></div>
            <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#27CA40' }}></div>
          </div>
          
          {/* URL Bar */}
          <div 
            className="flex-1 px-4 py-2 rounded-md text-sm"
            style={{ backgroundColor: '#2E2E2C', color: '#9CA3AF' }}
          >
            https://lab.sleeve.dev/aurix-trace32
          </div>
        </div>
        
        {/* Browser Content */}
        <div className="p-6 space-y-4">
          
          {/* Lauterbach TRACE32 Card */}
          <div 
            className="rounded-lg p-5"
            style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
          >
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-3">
                <div 
                  className="w-8 h-8 rounded flex items-center justify-center"
                  style={{ backgroundColor: 'rgba(79, 179, 184, 0.15)' }}
                >
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
                    <rect x="4" y="4" width="16" height="16" rx="2" />
                    <circle cx="12" cy="12" r="3" />
                    <line x1="4" y1="12" x2="9" y2="12" />
                    <line x1="15" y1="12" x2="20" y2="12" />
                    <line x1="12" y1="4" x2="12" y2="9" />
                    <line x1="12" y1="15" x2="12" y2="20" />
                  </svg>
                </div>
                <span className="font-semibold text-sm" style={{ color: '#E8EDDF' }}>Lauterbach TRACE32</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></div>
                <span className="text-xs" style={{ color: '#4FB3B8' }}>Connected</span>
              </div>
            </div>
            <div className="space-y-1">
              <p className="text-sm font-medium" style={{ color: '#4FB3B8' }}>AURIX TC3xx @ 0x80000000</p>
              <p className="text-xs" style={{ color: '#9CA3AF' }}>Core 0: Running | Core 1: Halted</p>
              <p className="text-xs" style={{ color: '#9CA3AF' }}>Breakpoint hit: main.c:247</p>
            </div>
          </div>
          
          {/* Terminal Card */}
          <div 
            className="rounded-lg p-5"
            style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
          >
            <div className="flex items-center gap-3 mb-3">
              <span className="font-mono text-sm" style={{ color: '#9CA3AF' }}>&gt;_</span>
              <span className="font-semibold text-sm" style={{ color: '#E8EDDF' }}>Terminal</span>
            </div>
            <div className="space-y-1 font-mono text-xs">
              <p style={{ color: '#4FB3B8' }}>$ ./flash_firmware.sh</p>
              <p style={{ color: '#9CA3AF' }}>Flashing AURIX target...</p>
              <p style={{ color: '#27CA40' }}>✓ Upload complete [2.4s]</p>
            </div>
          </div>
          
          {/* Eclipse IDE Card */}
          <div 
            className="rounded-lg p-5"
            style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
          >
            <div className="flex items-center gap-3 mb-3">
              <span className="font-mono text-sm" style={{ color: '#9CA3AF' }}>&lt;&gt;</span>
              <span className="font-semibold text-sm" style={{ color: '#E8EDDF' }}>Eclipse IDE</span>
            </div>
            <div className="space-y-1 font-mono text-xs">
              <p style={{ color: '#6B7280' }}>// Real hardware debugging session</p>
              <p style={{ color: '#E8EDDF' }}>void safety_monitor(void) {'{'}</p>
              <p style={{ color: '#E8EDDF' }}>&nbsp;&nbsp;&nbsp;&nbsp;task_exec();</p>
              <p style={{ color: '#E8EDDF' }}>{'}'}</p>
            </div>
          </div>
          
        </div>
      </div>
      
    </div>
    
  </div>
</section>

      {/* Backed by Innovators and Research Leaders */}
      <PartnersSection />

{/* Your Challenge Is Scaling Expertise */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        Your Challenge Is Scaling Expertise
      </h2>
      <p className="text-base md:text-lg max-w-3xl mx-auto" style={{ color: '#9CA3AF' }}>
        Traditional training infrastructure doesn't scale with your engineering organization.
      </p>
    </div>
    
    {/* Two Comparison Cards */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
      
      {/* Left Card - THE OLD WAY */}
      <div 
        className="rounded-l-xl p-8 lg:p-10"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <span className="text-xs font-bold tracking-wider" style={{ color: '#FF6B6B' }}>THE OLD WAY</span>
        
        <h3 className="text-2xl md:text-3xl font-bold mt-3 mb-8" style={{ color: '#E8EDDF' }}>
          Hardware-Constrained Training
        </h3>
        
        <div className="space-y-6">
          
          {/* Slow onboarding */}
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 mt-1">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
            </div>
            <div>
              <h4 className="text-sm font-bold mb-1" style={{ color: '#E8EDDF' }}>Slow onboarding and hardware setup</h4>
              <p className="text-sm" style={{ color: '#9CA3AF' }}>
                Engineers wait weeks for lab access, hardware availability, tool installation
              </p>
            </div>
          </div>
          
          {/* Shared equipment */}
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 mt-1">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
              </svg>
            </div>
            <div>
              <h4 className="text-sm font-bold mb-1" style={{ color: '#E8EDDF' }}>Shared $50K+ lab equipment</h4>
              <p className="text-sm" style={{ color: '#9CA3AF' }}>
                Limited hardware creates training bottlenecks, scheduling conflicts, idle engineers
              </p>
            </div>
          </div>
          
          {/* Travel-heavy */}
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 mt-1">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <div>
              <h4 className="text-sm font-bold mb-1" style={{ color: '#E8EDDF' }}>Travel-heavy training</h4>
              <p className="text-sm" style={{ color: '#9CA3AF' }}>
                Engineers travel to training centers, logistics overhead, time away from projects
              </p>
            </div>
          </div>
          
        </div>
      </div>
      
      {/* Right Card - THE SLEEVE.DEV WAY */}
      <div 
        className="rounded-r-xl p-8 lg:p-10"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38', borderLeft: 'none' }}
      >
        <span className="text-xs font-bold tracking-wider" style={{ color: '#4FB3B8' }}>THE SLEEVE.DEV WAY</span>
        
        <h3 className="text-2xl md:text-3xl font-bold mt-3 mb-8" style={{ color: '#E8EDDF' }}>
          On-Demand Hardware Access
        </h3>
        
        <div className="space-y-6">
          
          {/* Instant browser-based */}
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 mt-1">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
              </svg>
            </div>
            <div>
              <h4 className="text-sm font-bold mb-1" style={{ color: '#E8EDDF' }}>Instant browser-based access</h4>
              <p className="text-sm" style={{ color: '#9CA3AF' }}>
                Engineers start training immediately in any browser, no setup or installation required
              </p>
            </div>
          </div>
          
          {/* Parallel access */}
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 mt-1">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
                <rect x="3" y="3" width="7" height="7" rx="1" />
                <rect x="14" y="3" width="7" height="7" rx="1" />
                <rect x="3" y="14" width="7" height="7" rx="1" />
                <rect x="14" y="14" width="7" height="7" rx="1" />
              </svg>
            </div>
            <div>
              <h4 className="text-sm font-bold mb-1" style={{ color: '#E8EDDF' }}>Parallel access for every engineer</h4>
              <p className="text-sm" style={{ color: '#9CA3AF' }}>
                Real hardware instances scale to match team size, no scheduling conflicts
              </p>
            </div>
          </div>
          
          {/* Zero travel */}
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 mt-1">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
              </svg>
            </div>
            <div>
              <h4 className="text-sm font-bold mb-1" style={{ color: '#E8EDDF' }}>Zero travel, zero logistics</h4>
              <p className="text-sm" style={{ color: '#9CA3AF' }}>
                Distributed teams train on identical hardware environments from anywhere
              </p>
            </div>
          </div>
          
        </div>
      </div>
      
    </div>
    
  </div>
</section>

{/* The World's Most Advanced Embedded Lab — Delivered */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        The World's Most Advanced Embedded Lab — Delivered
      </h2>
      <p className="text-base md:text-lg" style={{ color: '#9CA3AF' }}>
        Real hardware, professional tooling, instant access.
      </p>
    </div>
    
    {/* Four Steps Row */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8 items-stretch">
      
      {/* Step 1 - Select Module */}
      <div className="relative flex">
        <div 
          className="rounded-xl p-6 flex-1"
          style={{ backgroundColor: '#2E2E2C', border: '2px dashed #4FB3B8' }}
        >
          <div className="flex items-center gap-3 mb-4">
            <div 
              className="w-7 h-7 rounded flex items-center justify-center text-sm font-bold"
              style={{ backgroundColor: '#4FB3B8', color: '#242423' }}
            >
              1
            </div>
            <h3 className="text-base font-bold" style={{ color: '#E8EDDF' }}>Select Module</h3>
          </div>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Choose from certified training modules covering AUTOSAR, embedded debugging, TRACE32, or custom workshops.
          </p>
        </div>
        {/* Arrow - visible on lg screens */}
        <div className="hidden lg:flex items-center absolute -right-3 top-1/2 -translate-y-1/2 z-10">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M7 4 L13 10 L7 16" stroke="#4FB3B8" strokeWidth="2" fill="none" />
          </svg>
        </div>
      </div>
      
      {/* Step 2 - Launch Lab */}
      <div className="relative flex">
        <div 
          className="rounded-xl p-6 flex-1"
          style={{ backgroundColor: '#2E2E2C', border: '2px dashed #4FB3B8' }}
        >
          <div className="flex items-center gap-3 mb-4">
            <div 
              className="w-7 h-7 rounded flex items-center justify-center text-sm font-bold"
              style={{ backgroundColor: '#4FB3B8', color: '#242423' }}
            >
              2
            </div>
            <h3 className="text-base font-bold" style={{ color: '#E8EDDF' }}>Launch Lab</h3>
          </div>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Click to launch a browser-based lab environment with all tools pre-configured and ready.
          </p>
        </div>
        {/* Arrow */}
        <div className="hidden lg:flex items-center absolute -right-3 top-1/2 -translate-y-1/2 z-10">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M7 4 L13 10 L7 16" stroke="#4FB3B8" strokeWidth="2" fill="none" />
          </svg>
        </div>
      </div>
      
      {/* Step 3 - Connect to Hardware */}
      <div className="relative flex">
        <div 
          className="rounded-xl p-6 flex-1"
          style={{ backgroundColor: '#2E2E2C', border: '2px dashed #4FB3B8' }}
        >
          <div className="flex items-center gap-3 mb-4">
            <div 
              className="w-7 h-7 rounded flex items-center justify-center text-sm font-bold"
              style={{ backgroundColor: '#4FB3B8', color: '#242423' }}
            >
              3
            </div>
            <h3 className="text-base font-bold" style={{ color: '#E8EDDF' }}>Connect to Hardware</h3>
          </div>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Sleeve connects you to real silicon — Infineon AURIX, NVIDIA Orin, NXP GoldBox — not simulators.
          </p>
        </div>
        {/* Arrow */}
        <div className="hidden lg:flex items-center absolute -right-3 top-1/2 -translate-y-1/2 z-10">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M7 4 L13 10 L7 16" stroke="#4FB3B8" strokeWidth="2" fill="none" />
          </svg>
        </div>
      </div>
      
      {/* Step 4 - Train & Scale */}
      <div className="flex">
        <div 
          className="rounded-xl p-6 flex-1"
          style={{ backgroundColor: '#2E2E2C', border: '2px dashed #4FB3B8' }}
        >
          <div className="flex items-center gap-3 mb-4">
            <div 
              className="w-7 h-7 rounded flex items-center justify-center text-sm font-bold"
              style={{ backgroundColor: '#4FB3B8', color: '#242423' }}
            >
              4
            </div>
            <h3 className="text-base font-bold" style={{ color: '#E8EDDF' }}>Train & Scale</h3>
          </div>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Complete hands-on exercises, validate competency, and scale training across your entire engineering organization.
          </p>
        </div>
      </div>
      
    </div>
    
    {/* Three Feature Cards */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      
      {/* No Virtualization Tricks */}
      <div 
        className="rounded-xl p-8 text-center"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex justify-center mb-4">
          <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="1.5">
            <path d="M12 2L4 6v6c0 5.5 3.4 10.6 8 12 4.6-1.4 8-6.5 8-12V6l-8-4z" />
          </svg>
        </div>
        <h3 className="text-base font-bold mb-2" style={{ color: '#E8EDDF' }}>No Virtualization Tricks</h3>
        <p className="text-sm" style={{ color: '#9CA3AF' }}>
          Real physical hardware, not emulation or simulation
        </p>
      </div>
      
      {/* No Local Installs */}
      <div 
        className="rounded-xl p-8 text-center"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex justify-center mb-4">
          <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
          </svg>
        </div>
        <h3 className="text-base font-bold mb-2" style={{ color: '#E8EDDF' }}>No Local Installs</h3>
        <p className="text-sm" style={{ color: '#9CA3AF' }}>
          Browser-based access from any device, any location
        </p>
      </div>
      
      {/* Real Silicon, Real Debuggers */}
      <div 
        className="rounded-xl p-8 text-center"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex justify-center mb-4">
          <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="1.5">
            <rect x="4" y="4" width="16" height="16" rx="2" />
            <rect x="8" y="8" width="8" height="8" rx="1" />
            <line x1="12" y1="2" x2="12" y2="4" />
            <line x1="12" y1="20" x2="12" y2="22" />
            <line x1="2" y1="12" x2="4" y2="12" />
            <line x1="20" y1="12" x2="22" y2="12" />
            <line x1="6" y1="2" x2="6" y2="4" />
            <line x1="18" y1="2" x2="18" y2="4" />
            <line x1="6" y1="20" x2="6" y2="22" />
            <line x1="18" y1="20" x2="18" y2="22" />
            <line x1="2" y1="6" x2="4" y2="6" />
            <line x1="2" y1="18" x2="4" y2="18" />
            <line x1="20" y1="6" x2="22" y2="6" />
            <line x1="20" y1="18" x2="22" y2="18" />
          </svg>
        </div>
        <h3 className="text-base font-bold mb-2" style={{ color: '#E8EDDF' }}>Real Silicon, Real Debuggers</h3>
        <p className="text-sm" style={{ color: '#9CA3AF' }}>
          Professional toolchains and industry-standard debuggers
        </p>
      </div>
      
    </div>
    
  </div>
</section>

{/* Real Tools. Real Workflows. */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        Real Tools. Real Workflows.
      </h2>
      <p className="text-base md:text-lg" style={{ color: '#9CA3AF' }}>
        Train on the same professional tooling your team uses in production.
      </p>
    </div>
    
    {/* Two Columns */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
      
      {/* Left Column - Hardware Platforms */}
      <div>
        <span className="text-xs font-bold tracking-wider" style={{ color: '#F5CB5C' }}>HARDWARE PLATFORMS</span>
        <h3 className="text-2xl md:text-3xl font-bold mt-2 mb-8" style={{ color: '#E8EDDF' }}>
          Industry-Standard Silicon
        </h3>
        
        <div className="space-y-4">
          
          {/* Infineon AURIX TC3xx */}
          <div 
            className="rounded-xl p-5 flex items-start gap-4"
            style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
          >
            <div 
              className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: '#3A3A38' }}
            >
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <rect x="8" y="8" width="8" height="8" rx="1" />
                <line x1="12" y1="2" x2="12" y2="4" />
                <line x1="12" y1="20" x2="12" y2="22" />
                <line x1="2" y1="12" x2="4" y2="12" />
                <line x1="20" y1="12" x2="22" y2="12" />
                <line x1="6" y1="2" x2="6" y2="4" />
                <line x1="18" y1="2" x2="18" y2="4" />
                <line x1="6" y1="20" x2="6" y2="22" />
                <line x1="18" y1="20" x2="18" y2="22" />
              </svg>
            </div>
            <div>
              <h4 className="text-base font-bold mb-1" style={{ color: '#E8EDDF' }}>Infineon AURIX TC3xx</h4>
              <p className="text-sm" style={{ color: '#9CA3AF' }}>
                Multi-core lockstep architecture, AUTOSAR-compliant, automotive safety
              </p>
            </div>
          </div>
          
          {/* NVIDIA Orin / Jetson */}
          <div 
            className="rounded-xl p-5 flex items-start gap-4"
            style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
          >
            <div 
              className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: '#3A3A38' }}
            >
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <rect x="8" y="8" width="8" height="8" rx="1" />
                <line x1="12" y1="2" x2="12" y2="4" />
                <line x1="12" y1="20" x2="12" y2="22" />
                <line x1="2" y1="12" x2="4" y2="12" />
                <line x1="20" y1="12" x2="22" y2="12" />
                <line x1="6" y1="2" x2="6" y2="4" />
                <line x1="18" y1="2" x2="18" y2="4" />
                <line x1="6" y1="20" x2="6" y2="22" />
                <line x1="18" y1="20" x2="18" y2="22" />
              </svg>
            </div>
            <div>
              <h4 className="text-base font-bold mb-1" style={{ color: '#E8EDDF' }}>NVIDIA Orin / Jetson</h4>
              <p className="text-sm" style={{ color: '#9CA3AF' }}>
                AI/ML acceleration, autonomous systems, CUDA development
              </p>
            </div>
          </div>
          
          {/* NXP GoldBox */}
          <div 
            className="rounded-xl p-5 flex items-start gap-4"
            style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
          >
            <div 
              className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: '#3A3A38' }}
            >
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <rect x="8" y="8" width="8" height="8" rx="1" />
                <line x1="12" y1="2" x2="12" y2="4" />
                <line x1="12" y1="20" x2="12" y2="22" />
                <line x1="2" y1="12" x2="4" y2="12" />
                <line x1="20" y1="12" x2="22" y2="12" />
                <line x1="6" y1="2" x2="6" y2="4" />
                <line x1="18" y1="2" x2="18" y2="4" />
                <line x1="6" y1="20" x2="6" y2="22" />
                <line x1="18" y1="20" x2="18" y2="22" />
              </svg>
            </div>
            <div>
              <h4 className="text-base font-bold mb-1" style={{ color: '#E8EDDF' }}>NXP GoldBox</h4>
              <p className="text-sm" style={{ color: '#9CA3AF' }}>
                Automotive gateway development, CAN/LIN/FlexRAY protocols
              </p>
            </div>
          </div>
          
        </div>
      </div>
      
      {/* Right Column - Professional Tooling */}
      <div>
        <span className="text-xs font-bold tracking-wider" style={{ color: '#F5CB5C' }}>PROFESSIONAL TOOLING</span>
        <h3 className="text-2xl md:text-3xl font-bold mt-2 mb-8" style={{ color: '#E8EDDF' }}>
          Industry-Grade Development Tools
        </h3>
        
        <div className="space-y-4">
          
          {/* Lauterbach TRACE32 */}
          <div 
            className="rounded-xl p-5 flex items-start gap-4"
            style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
          >
            <div 
              className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: '#3A3A38' }}
            >
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
                <polyline points="4 17 10 11 4 5" />
                <line x1="12" y1="19" x2="20" y2="19" />
              </svg>
            </div>
            <div>
              <h4 className="text-base font-bold mb-1" style={{ color: '#E8EDDF' }}>Lauterbach TRACE32</h4>
              <p className="text-sm" style={{ color: '#9CA3AF' }}>
                Multi-core debugging, trace analysis, AUTOSAR awareness
              </p>
            </div>
          </div>
          
          {/* Gliwa T1 / ETAS INCA */}
          <div 
            className="rounded-xl p-5 flex items-start gap-4"
            style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
          >
            <div 
              className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: '#3A3A38' }}
            >
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 2 12 8 18 14 2" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
              </svg>
            </div>
            <div>
              <h4 className="text-base font-bold mb-1" style={{ color: '#E8EDDF' }}>Gliwa T1 / ETAS INCA</h4>
              <p className="text-sm" style={{ color: '#9CA3AF' }}>
                Timing analysis, calibration, measurement and data acquisition
              </p>
            </div>
          </div>
          
          {/* Eclipse / Theia IDE */}
          <div 
            className="rounded-xl p-5 flex items-start gap-4"
            style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
          >
            <div 
              className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: '#3A3A38' }}
            >
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
                <polyline points="16 18 22 12 16 6" />
                <polyline points="8 6 2 12 8 18" />
              </svg>
            </div>
            <div>
              <h4 className="text-base font-bold mb-1" style={{ color: '#E8EDDF' }}>Eclipse / Theia IDE</h4>
              <p className="text-sm" style={{ color: '#9CA3AF' }}>
                C/C++ development, AI coding assistants, version control integration
              </p>
            </div>
          </div>
          
        </div>
      </div>
      
    </div>
    
  </div>
</section>

{/* Stop Training. Start Certifying. */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        Stop Training. Start Certifying.
      </h2>
      <p className="text-base md:text-lg" style={{ color: '#9CA3AF' }}>
        Measurable training outcomes for engineering organizations.
      </p>
    </div>
    
    {/* Four Cards - 2x2 Grid */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      
      {/* 90% Faster Onboarding */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-start gap-5">
          <div 
            className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(245, 203, 92, 0.15)' }}
          >
            <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
              <polyline points="17 6 23 6 23 12" />
            </svg>
          </div>
          <div className="flex-1">
            <h3 className="text-2xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
              90% Faster Onboarding
            </h3>
            <p className="text-sm leading-relaxed mb-4" style={{ color: '#9CA3AF' }}>
              New engineers gain hands-on hardware experience in days instead of weeks. Instant lab access eliminates setup delays and hardware availability bottlenecks.
            </p>
            <p className="text-xs italic" style={{ color: '#6B7280' }}>
              Based on customer deployment reducing onboarding from 3 weeks to 2-3 days for AUTOSAR stack training.
            </p>
          </div>
        </div>
      </div>
      
      {/* Reduced CapEx on Training Hardware */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-start gap-5">
          <div 
            className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(79, 179, 184, 0.15)' }}
          >
            <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <line x1="9" y1="9" x2="15" y2="9" />
              <line x1="9" y1="13" x2="15" y2="13" />
              <line x1="9" y1="17" x2="12" y2="17" />
            </svg>
          </div>
          <div className="flex-1">
            <h3 className="text-2xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
              Reduced CapEx on Training Hardware
            </h3>
            <p className="text-sm leading-relaxed mb-4" style={{ color: '#9CA3AF' }}>
              Eliminate the need for duplicate training lab infrastructure. One Sleeve deployment replaces physical hardware procurement for every new engineer.
            </p>
            <p className="text-xs italic" style={{ color: '#6B7280' }}>
              Typical embedded lab setup costs $50K-100K per seat. Sleeve provides parallel access at a fraction of the cost.
            </p>
          </div>
        </div>
      </div>
      
      {/* Measurable Time-to-Competence */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-start gap-5">
          <div 
            className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(245, 203, 92, 0.15)' }}
          >
            <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          </div>
          <div className="flex-1">
            <h3 className="text-2xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
              Measurable Time-to-Competence
            </h3>
            <p className="text-sm leading-relaxed mb-4" style={{ color: '#9CA3AF' }}>
              Track engineer progress through structured modules with completion metrics. Quantify training effectiveness with lab session data and skill validation checkpoints.
            </p>
            <p className="text-xs italic" style={{ color: '#6B7280' }}>
              Dashboard shows per-engineer lab time, module completion rate, and competency milestones.
            </p>
          </div>
        </div>
      </div>
      
      {/* Consistent, Auditable Environments */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-start gap-5">
          <div 
            className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(245, 203, 92, 0.15)' }}
          >
            <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M12 2L4 6v6c0 5.5 3.4 10.6 8 12 4.6-1.4 8-6.5 8-12V6l-8-4z" />
            </svg>
          </div>
          <div className="flex-1">
            <h3 className="text-2xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
              Consistent, Auditable Environments
            </h3>
            <p className="text-sm leading-relaxed mb-4" style={{ color: '#9CA3AF' }}>
              Every engineer trains on identical hardware and tooling configurations. Ensure compliance with internal training requirements and industry standards.
            </p>
            <p className="text-xs italic" style={{ color: '#6B7280' }}>
              Critical for safety-critical systems development and regulatory environments (ISO 26262, IEC 61508).
            </p>
          </div>
        </div>
      </div>
      
    </div>
    
  </div>
</section>


{/* Team Programs */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-5xl mx-auto">
    
    {/* Single Card */}
    <div 
      className="rounded-xl p-10 md:p-12"
      style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12">
        
        {/* Left Column */}
        <div>
          {/* Icon */}
          <div 
            className="w-16 h-16 rounded-xl flex items-center justify-center mb-6"
            style={{ backgroundColor: '#3A3A38' }}
          >
            <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="1.5">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          
          {/* Label */}
          <span className="text-xs font-bold tracking-wider" style={{ color: '#4FB3B8' }}>
            ENTERPRISE TRAINING
          </span>
          
          {/* Title */}
          <h2 className="text-3xl md:text-4xl font-bold mt-2" style={{ color: '#E8EDDF' }}>
            Team Programs
          </h2>
        </div>
        
        {/* Right Column */}
        <div>
          {/* Intro Paragraph */}
          <p className="text-base leading-relaxed mb-8" style={{ color: '#9CA3AF' }}>
            Sleeve supports team-wide training programs with custom workshops, progress tracking, and certification support for engineering organizations.
          </p>
          
          {/* Features List */}
          <div className="space-y-6">
            
            {/* Team-Wide Training Programs */}
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <div>
                <h4 className="text-base font-bold mb-1" style={{ color: '#E8EDDF' }}>Team-Wide Training Programs</h4>
                <p className="text-sm" style={{ color: '#9CA3AF' }}>
                  Onboard entire engineering teams with structured learning paths and consistent lab environments
                </p>
              </div>
            </div>
            
            {/* Custom Workshops */}
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <div>
                <h4 className="text-base font-bold mb-1" style={{ color: '#E8EDDF' }}>Custom Workshops</h4>
                <p className="text-sm" style={{ color: '#9CA3AF' }}>
                  Tailored training modules addressing specific toolchains, hardware platforms, or internal development workflows
                </p>
              </div>
            </div>
            
            {/* Progress Tracking & Certification */}
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <div>
                <h4 className="text-base font-bold mb-1" style={{ color: '#E8EDDF' }}>Progress Tracking & Certification</h4>
                <p className="text-sm" style={{ color: '#9CA3AF' }}>
                  Manager dashboards showing team progress, completion rates, and skill validation checkpoints
                </p>
              </div>
            </div>
            
          </div>
        </div>
        
      </div>
    </div>
    
  </div>
</section>

      {/* Final CTA */}
      <section className="py-24 md:py-32 px-4 md:px-6 lg:px-8 border-b border-border">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl font-bold text-foreground mb-6">
            Get Started with Sleeve Training Platform
          </h2>
          
          <div className="flex flex-wrap gap-4">
            <a
              href="https://hub.sleeve.dev"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors"
            >
              Start Your Free 30-Minute Lab
              <Icon name="ArrowRight" size={16} />
            </a>
            <Link 
              to="/contact" 
              className="inline-flex items-center gap-2 px-6 py-3 bg-card border border-border text-foreground rounded-lg font-medium hover:bg-card/80 transition-colors"
            >
              Request Team Training Quote
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TrainingPlatformUseCaseDetail;